<ng-template #templateModalRespostaAvaliacao>
    <div class="modal-resposta-avaliacao">
        <div class="modal-header">
            <section class="modal-title">
                {{ 'buyer.cotacao.area-respostas.modal-avaliacao.titulo' | translate }}
            </section>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <ng-template #ratingTooltip>
                <div class="information-tooltip rating">
                    <div>
                        <i-feather name="star"></i-feather>
                    </div>
                    <b>{{ 'buyer.cotacao.area-respostas.resposta.cabecalho.tip-nota.titulo' | translate}}</b>
                    <p>{{ 'buyer.cotacao.area-respostas.resposta.cabecalho.tip-nota.subtitulo' | translate}}</p>
                </div>
            </ng-template>

            <ng-template #positionTooltip>
                <div class="information-tooltip position">
                    <div>
                        <i-feather name="award"></i-feather>
                    </div>
                    <b>{{ 'buyer.cotacao.area-respostas.resposta.cabecalho.tip-posicao.titulo' | translate: {position: sellerReview?.position} }}</b>
                    <p>{{ 'buyer.cotacao.area-respostas.resposta.cabecalho.tip-posicao.subtitulo' | translate: {position: sellerReview?.position} }}</p>
                </div>
            </ng-template>

            <ng-template #scoreTooltip>
                <div class="information-tooltip score">
                    <div>
                        <i-feather name="thermometer"></i-feather>
                    </div>
                    <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.tip-score.titulo' | translate }}</b>
                    <p>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.tip-score.subtitulo' | translate }}</p>
                </div>
            </ng-template>

            <ng-template #ratingAllBrandsTooltip>
                <div class="information-tooltip position">
                    <div>
                        <i-feather name="thumbs-up"></i-feather>
                    </div>
                    <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.tip-all-brands.titulo' | translate }}</b>
                    <p>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.tip-all-brands.subtitulo' | translate }}</p>
                </div>
            </ng-template>

            <ng-template #salesNumberBrandTooltip>
                <div class="information-tooltip sales">
                    <div>
                        <i-feather name="info"></i-feather>
                    </div>
                    <b>{{ 'buyer.cotacao.area-respostas.resposta.cabecalho.tip-sales-number-brand.titulo' | translate }}</b>
                    <p>{{ 'buyer.cotacao.area-respostas.resposta.cabecalho.tip-sales-number-brand.subtitulo' | translate: {brand: brandName} }}</p>
                </div>
            </ng-template>

            @if (sellerReview) {
                <ng-scrollbar>
                    <div class="content">
                        <div class="basic-information">
                            <div class="user">
                                <div class="user-header">
                                    <div class="username">
                                        <i-feather name="user"></i-feather>
                                        <p class="truncate">{{sellerReview?.seller_name}}</p>
                                    </div>
                                    @if (sellerReview?.position <= 5 && sellerReview?.position > 0) {
                                        <div class="selling-position" [ngbTooltip]="positionTooltip"    tooltipClass="information-tooltip-window" container="body" placement="bottom" [openDelay]="500">
                                            <i-feather name="award"></i-feather>
                                            <p>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.top' | translate}} {{sellerReview?.position}}</p>
                                        </div>
                                    }
                                </div>
                                <div class="user-body">
                                    <section>
                                        <div class="item">
                                            <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.email' | translate }}</b>
                                            <p class="truncate">{{sellerReview?.seller_email}}</p>
                                        </div>
                                        <div class="item">
                                            <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.tempo-partsfy' | translate }}</b>
                                            <p>{{sellerReview?.seller_partsfy_years == 0 ?
                                                ('buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.primeiro-ano-partsfy' | translate) :
                                            ("+ " + sellerReview?.seller_partsfy_years + (sellerReview?.seller_partsfy_years > 1 ? " anos" : " ano"))}}</p>
                                        </div>
                                        <div class="item">
                                            <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.localizacao' | translate }}</b>
                                            <p>{{sellerReview?.supplier_city}}</p>
                                        </div>
                                    </section>
                                    <section class="second-section">
                                        <div class="item">
                                            <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.whatsapp' | translate }}</b>
                                            <p>{{sellerReview?.seller_whatsapp_formated}}</p>
                                        </div>
                                        <div class="item sales-number-brand">
                                            <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.informacao-usuario.numero-vendas' | translate }}</b>
                                            <div class="tip-sales-number-brand" [ngbTooltip]="salesNumberBrandTooltip" tooltipClass="information-tooltip-window" container="body" placement="bottom" [openDelay]="500">
                                                <i-feather name="info"></i-feather>
                                            </div>
                                            <p>{{sellerReview?.total_sales_formated > 100 ? "+" : ""}} {{sellerReview?.total_sales_formated >= 1000 ? (sellerReview?.total_sales_formated / 1000 | number:'.1') + " mil" : sellerReview?.total_sales_formated}}</p>
                                        </div>
                                    </section>
                                    <section>
                                        <div class="card-informations">
                                            <div class="costumer-rate" [ngbTooltip]="scoreTooltip"    tooltipClass="information-tooltip-window" container="body" placement="bottom" [openDelay]="500">
                                                <div class="title">
                                                    <i-feather name="thermometer"></i-feather>
                                                    <p [ngClass]="{
                                                            'low': sellerReview?.score <= 3,
                                                            'medium-low': sellerReview?.score > 3 && sellerReview?.score <= 5,
                                                            'medium': sellerReview?.score > 5 && sellerReview?.score <= 7,
                                                            'medium-high': sellerReview?.score > 7 && sellerReview?.score <= 9,
                                                            'high': sellerReview?.score > 9
                                                    }">{{sellerReview?.score | number: (sellerReview?.score < 10 ? '.2' : '1.0-0')}}/10</p>
                                                </div>
                                            <p class="subtitle">{{ 'buyer.cotacao.area-respostas.modal-avaliacao.label-score' | translate }}</p>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <div class="rating-information">
                            <div class="title">
                                <b>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.nota-geral.titulo' | translate }}</b>
                                <p>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.nota-geral.subtitulo' | translate }}</p>
                            </div>
                            <div class="rating" [ngbTooltip]="ratingTooltip"    tooltipClass="information-tooltip-window" container="body" placement="bottom" [openDelay]="500">
                                @if (sellerReview?.total_reviews <= 0) {
                                    <div class="no-rating">
                                        {{ 'buyer.cotacao.area-respostas.modal-avaliacao.nota-geral.sem-avaliacao' | translate }}
                                    </div>
                                }
                                @if (sellerReview?.total_reviews > 0) {
                                    <div class="visual-rating">
                                        <span class="rating-color low" [ngClass]="{ 'actual-rating': sellerReview?.rating <= 1 }"></span>
                                        <span class="rating-color medium-low" [ngClass]="{ 'actual-rating': sellerReview?.rating > 1 && sellerReview?.rating <= 2 }"></span>
                                        <span class="rating-color medium" [ngClass]="{ 'actual-rating': sellerReview?.rating > 2 && sellerReview?.rating <= 3 }"></span>
                                        <span class="rating-color medium-high" [ngClass]="{ 'actual-rating': sellerReview?.rating > 3 && sellerReview?.rating <= 4 }"></span>
                                        <span class="rating-color high" [ngClass]="{ 'actual-rating': sellerReview?.rating > 4 }"></span>
                                    </div>
                                }
                                @if (sellerReview?.total_reviews > 0) {
                                    <div class="numeric-rating" [ngClass]="{
                                            'low': sellerReview?.rating <= 1,
                                            'medium-low': sellerReview?.rating > 1 && sellerReview?.rating <= 2,
                                            'medium': sellerReview?.rating > 2 && sellerReview?.rating <= 3,
                                            'medium-high': sellerReview?.rating > 3 && sellerReview?.rating <= 4,
                                            'high': sellerReview?.rating > 4
                                    }">
                                        <p>{{sellerReview?.rating | number:'.1'}}</p>
                                        <i-feather name="star"></i-feather>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="comments">
                            <div class="title">
                                <div class="comments-rating">
                                    <i-feather name="thumbs-up"></i-feather>
                                </div>
                                <p>{{ 'buyer.cotacao.area-respostas.modal-avaliacao.avaliacoes.titulo' | translate }}<small>({{sellerReview?.total_reviews}})</small></p>
                                <div class="tip-comments-rating">
                                    <div [ngbTooltip]="ratingAllBrandsTooltip" tooltipClass="information-tooltip-window" container="body"
                                        placement="bottom" [openDelay]="500">
                                        <i-feather name="info" class="rating-all-brands-feather"></i-feather>
                                    </div>
                                </div>
                            </div>
                            @if (sellerReview?.reviews.length > 0) {
                                <div class="comments-list">
                                    @for (review of sellerReview?.reviews; track review) {
                                        <div class="comment">
                                            <i-feather [ngClass]="{'negative': !review.foi_bom}" name="thumbs-{{review.foi_bom ? 'up' : 'down'}}"></i-feather>
                                            <div>
                                                <p>{{review.buyer_name}} {{ review.repairer_name ? "(" + review.repairer_name + ")" : ""}}</p>
                                                <small>{{review.feedback_date_formated}} {{review.comentario && isUsuarioCentral ? ' - ' + review.comentario : ''}}</small>
                                            </div>
                                        </div>
                                    }
                                </div>
                            } @else {
                                <div class="vazio">
                                    {{ 'buyer.cotacao.area-respostas.modal-avaliacao.avaliacoes.sem-avaliacoes' | translate }}
                                </div>
                            }
                            @if (sellerReview.reviews.length < sellerReview.total_reviews) {
                                <p class="load-comments" (click)="loadMoreSellerReviews()">{{ 'buyer.cotacao.area-respostas.modal-avaliacao.avaliacoes.botao' | translate }}</p>
                            }
                        </div>
                    </div>
                </ng-scrollbar>
            }
        </div>
    </div>
    <ngx-ui-loader [loaderId]="'loader-reviews'"></ngx-ui-loader>
</ng-template>
